var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmusementParkThumbnailGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#F1F2F3",
    stroke: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_3345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.4736,
    y: 7,
    width: 1.34213,
    height: 12.5266,
    rx: 0.671066,
    fill: "#22343C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0697 11.8094L30.0675 8.10219C29.7627 7.91394 29.3696 8.13318 29.3696 8.49141V13.7875C29.3696 14.0877 29.6539 14.3065 29.9442 14.2297L35.9464 12.6409C36.3347 12.5381 36.4115 12.0205 36.0697 11.8094Z",
    fill: "#9DA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-roof",
    d: "M28.1974 15.8518C28.3721 15.6298 28.639 15.5002 28.9215 15.5002C29.204 15.5002 29.4708 15.6298 29.6455 15.8518L47.93 39.0884C49.1108 40.5889 48.0418 42.7902 46.1324 42.7902H11.7106C9.80112 42.7902 8.73218 40.5889 9.91296 39.0884L28.1974 15.8518Z",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-roof-shadow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4521 16.8746L29.6473 15.8518C29.4726 15.6298 29.2057 15.5002 28.9232 15.5002C28.6407 15.5002 28.3739 15.6298 28.1992 15.8518L9.91471 39.0884C8.73393 40.5889 9.80287 42.7902 11.7123 42.7902H20.7518L30.4521 16.8746Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-entrance-door",
    d: "M7 36.5269H13.6435V42.3428H19.4013V36.5269H26.0448V42.3428H31.8026V36.5269H38.4461V42.3428H44.6468V36.5269H51.2903V85.2336H40.6606V69.1854H40.6422C40.6544 68.9633 40.6606 68.7395 40.6606 68.5143C40.6606 61.9667 35.4058 56.6588 28.9237 56.6588C22.4416 56.6588 17.1868 61.9667 17.1868 68.5143C17.1868 68.7395 17.193 68.9633 17.2053 69.1854H17.1868V85.2336H7V36.5269Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-entrance-door-shadow",
    d: "M21.7634 36.5269H19.4013V42.3428H13.6435V36.5269H7V85.2336H17.1868V69.1854H17.2053C17.193 68.9633 17.1868 68.7395 17.1868 68.5143C17.1868 64.6895 18.9799 61.2876 21.7634 59.1198V36.5269Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-smoke",
    d: "M68.1227 49.5347C65.4245 48.8019 63.4414 46.3497 63.4414 43.4374C63.4414 39.9466 66.2906 37.1167 69.8053 37.1167C72.8497 37.1167 75.3948 39.2399 76.0214 42.0768C76.0988 42.0728 76.1768 42.0707 76.2552 42.0707C78.6775 42.0707 80.6411 44.021 80.6411 46.4269C80.6411 48.689 78.905 50.5484 76.6839 50.7625C76.6848 50.7977 76.6852 50.833 76.6852 50.8684C76.6852 53.2742 74.7216 55.2245 72.2993 55.2245C69.877 55.2245 67.9133 53.2742 67.9133 50.8684C67.9133 50.4032 67.9867 49.9551 68.1227 49.5347Z",
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-detail",
    d: "M67.9131 56.4124H77.2009L76.6849 64.2705H68.6011L67.9131 56.4124Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-detail",
    x: 29,
    y: 83.0713,
    width: 56.2871,
    height: 6.3891,
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-detail",
    d: "M94.7854 92.9023L85.9606 83.7311C85.8308 83.5962 85.6517 83.52 85.4645 83.52H80.6652C80.285 83.52 79.9768 83.8282 79.9768 84.2084V93.3796C79.9768 93.7598 80.285 94.0681 80.6652 94.0681H94.2893C94.8963 94.0681 95.2062 93.3397 94.7854 92.9023Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-train",
    cx: 83.163,
    cy: 74.5621,
    rx: 10.0206,
    ry: 9.55818,
    transform: "rotate(90 83.163 74.5621)",
    fill: "#9DA4AF"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-engine-shadow",
    x: 55.5505,
    y: 64.5415,
    width: 28.6745,
    height: 20.0413,
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train",
    d: "M33.5222 52.9387H56.6125V84.5829H29L29 80.9003C29 78.8576 30.6559 77.2016 32.6987 77.2016H33.5222V68.7608V52.9387Z",
    fill: "#9DA4AF"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-detail",
    x: 31.7939,
    y: 51.1167,
    width: 26.4876,
    height: 2.73326,
    rx: 0.809765,
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 36.4343,
    y: 56.1033,
    width: 16.9923,
    height: 14.7673,
    rx: 0.809765,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-detail",
    x: 35.406,
    y: 72.8198,
    width: 5.50391,
    height: 1.70829,
    rx: 0.809765,
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-train-engine",
    x: 56.5615,
    y: 66.1575,
    width: 27.6916,
    height: 5.46652,
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-wheel",
    d: "M54.0136 85.0341C54.0136 89.9003 50.0399 93.8567 45.1237 93.8567C40.2076 93.8567 36.2339 89.9003 36.2339 85.0341C36.2339 80.1679 40.2076 76.2114 45.1237 76.2114C50.0399 76.2114 54.0136 80.1679 54.0136 85.0341Z",
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-wheel",
    d: "M68.2865 88.4493C68.2865 91.4278 65.8536 93.8539 62.8381 93.8539C59.8226 93.8539 57.3896 91.4278 57.3896 88.4493C57.3896 85.4708 59.8226 83.0447 62.8381 83.0447C65.8536 83.0447 68.2865 85.4708 68.2865 88.4493Z",
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-wheel",
    d: "M82.8969 88.5213C82.8969 91.4998 80.464 93.9259 77.4484 93.9259C74.4329 93.9259 72 91.4998 72 88.5213C72 85.5428 74.4329 83.1167 77.4484 83.1167C80.464 83.1167 82.8969 85.5428 82.8969 88.5213Z",
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-train-detail",
    d: "M67.3486 54.7988C67.3768 54.6449 67.5108 54.5332 67.6672 54.5332H77.4471C77.6035 54.5332 77.7375 54.6449 77.7657 54.7988L77.9911 56.0301C78.0275 56.229 77.8747 56.4123 77.6725 56.4123H67.4418C67.2396 56.4123 67.0868 56.229 67.1232 56.0301L67.3486 54.7988Z",
    fill: "#505862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_3345",
    x: 6.08504,
    y: 6.54252,
    width: 89.8089,
    height: 89.7559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.457478
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.457478
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_3345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_3345",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmusementParkThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmusementParkThumbnailGray.726ffeb9d2abf89876f2fe254adcc785.svg";